import React from 'react';
import { COLOR_BY_REFUND_STATUS } from 'components/Refunds/styles';
import { StyledAccordion } from 'containers/AmcDetailsPage/MyRefundsTab/Refunds/styles';
import { REFUND_STATUSES } from 'constants/amcStatuses';
import { injectIntl, IntlShape } from 'react-intl';

import AgreementClaim from 'components/Refunds/AgreementClaim';
import ClosedClaim from 'components/Refunds/ClosedClaim';
import ComplementaryInfoClaim from 'components/Refunds/ComplementaryInfoClaim';
import PecCanceledClaim from 'components/Refunds/PecCanceledClaim';
import PecClaim from 'components/Refunds/PecClaim';
import RejectedClaim from 'components/Refunds/RejectedClaim';
import RejectedRegulationClaim from 'components/Refunds/RejectedRegulationClaim';
import ValidatedClaim from 'components/Refunds/ValidatedClaim';
import Pending from 'components/Refunds/Pending';
import ContreVisit from 'components/Refunds/ContreVisit';
import { StyledShortBody14 } from 'components/Refunds/styles';
import messages from 'components/Refunds/messages';
import { translate } from 'helpers/intl';
import { get } from 'lodash';

interface RefundsType {
  intl: IntlShape;
  refunds: {
    [key: string]: {
      statusApplication: String;
      numeroPolicy: String;
      numeroApplication: Number;
      beneficiary: String;
      dateNum: Number;
      years: Number;
      dateOccu: string;
    }[];
  };
  refundDetails: {
    numDossier: String;
    dateSurvenance: String;
    numSinistre: String;
    fraisEngagement: String;
    statusNum: Number;
    status: String;
    rib: String;
    montantRegle: String;
    modeReglement: String;
    dateEvenement: String;
  };
  expanded: boolean | String;
  handleChange: Function;
  listIndex: Number;
  isLoading: boolean;
}

const AccordionSinistre = ({
  refunds,
  refundDetails,
  listIndex,
  handleChange,
  expanded,
  isLoading,
  ...props
}: RefundsType) => {
  const renderDetails = (item: any, index: Number) => {
    switch (item.statusApplication) {
      case REFUND_STATUSES.AGREEMENT:
        return (
          <AgreementClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.RETURN:
        return (
          <RejectedRegulationClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.VISITE:
        return (
          <ContreVisit
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.REJECTED:
        return (
          <RejectedClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.PAIED:
        return (
          <ValidatedClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.PEC_CANCELED:
        return (
          <PecCanceledClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.PENDING:
        return (
          <Pending
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.COMPLEMENTARY_INFO:
        return (
          <ComplementaryInfoClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.PEC:
        return (
          <PecClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      case REFUND_STATUSES.S_SUITE:
        return (
          <ClosedClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
      default:
        return (
          <Pending
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}`}
          />
        );
    }
  };

  return (
    <>
      {Object.keys(refunds).map((key) => (
        <>
          <StyledShortBody14>{`${translate(
            get(messages, 'year'),
            props,
          )} ${key}`}</StyledShortBody14>
          {refunds[key].map((item: any, index: Number) => (
            <StyledAccordion
              color={
                COLOR_BY_REFUND_STATUS[item.statusApplication] ||
                COLOR_BY_REFUND_STATUS.DEFAULT
              }
              aria-controls={`panel-content-${index}`}
              id={`panel-header-${index}`}
              data-testid={`refund-item-${index}`}
              onChange={handleChange(`refund-${listIndex}-item-${index}`, item)}
              expanded={expanded === `refund-${listIndex}-item-${index}`}
            >
              {renderDetails(item, index)}
            </StyledAccordion>
          ))}
        </>
      ))}
    </>
  );
};

export default injectIntl(AccordionSinistre);
